import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import { getDashboardRedirect } from "./router/dashboardRedirect";
import { getMemberRedirect } from "./router/memberRedirect";

// View components for router
import AdminApp from "./views/admin/AdminApp";
import AdminMenu from "./views/admin/AdminMenu";
import AdminAutoAssignment from "./views/admin/autoAssignment/App";
import AdminDropdownList from "./views/admin/dropdown/AdminDropdownList";
import AdminDropdownView from "./views/admin/dropdown/AdminDropdownView";
import AdminExtract from "./views/admin/extract/AdminExtract";
import AdminOrganizationUserList from "./views/admin/user/AdminOrganizationUserList";
import AdminOrganizationSettings from "./views/admin/organizationSettings/App";
import AdminPackList from "./views/admin/pack/AdminPackList";
import AdminPackView from "./views/admin/pack/AdminPackView";
import AdminRole from "./views/admin/role/AdminRole";
import AdminTagList from "./views/admin/tag/AdminTagList";
import AdminServiceAreaCategoryList from "./views/admin/serviceAreaCategory/AdminServiceAreaCategoryList";
import AdminServiceAreaCategoryView from "./views/admin/serviceAreaCategory/AdminServiceAreaCategoryView";
import AdminServiceAreaList from "./views/admin/serviceArea/AdminServiceAreaList";
import AdminUserList from "./views/admin/user/AdminUserList";
import AdminApplication from "./views/admin/applicationAdmin/App";
import DashboardAccountManager from "./views/dashboard/accountManager/DashboardAccountManager";
import DashboardApp from "./views/dashboard/App";
import DashboardQaAnalyst from "./views/dashboard/DashboardQaAnalyst";
import DashboardUAT from "./views/dashboard/uat/DashboardUAT";
import ErrorPage from "./views/Error";
import LandingApp from "./views/landing/LandingApp";
import MemberTestStepApp from "./views/testStep/serviceArea/App";
import MemberTestStepEdit from "./views/testStep/serviceArea/Edit";
import PackApp from "./views/pack/App";
import PackForm from "./components/packForm";
import MemberPackEdit from "./views/pack/MemberPackEdit";
import ReleaseNoteApp from "./views/releaseNote/App";
import ReleaseNoteCreate from "./views/releaseNote/Create";
import ReleaseNoteEdit from "./views/releaseNote/Edit";
import ReleaseNoteList from "./views/releaseNote/List";
import ReleaseNotePrint from "./views/releaseNote/Print";
import ReleaseNoteView from "./views/releaseNote/View";
import SearchApp from "./views/search/App";
import TestPlanApp from "./views/testPlan/App";
import TestPlanEdit from "./views/testPlan/Edit";
import TestPlanList from "./views/testPlan/List";
import TestPlanPrint from "./views/testPlan/Print";
import TestPlanView from "./views/testPlan/View";
import TestStepApp from "./views/testStep/App";
import TestStepCreate from "./views/testStep/Create";
import TestStepEdit from "./views/testStep/Edit";
import TestStepView from "./views/testStep/View";
import TrainingAgreementApp from "./views/trainingAgreement/App";
import JiraQaImportList from "./views/jiraQaImport/JiraQaImportList";
import JiraQaImportCreate from "./views/jiraQaImport/JiraQaImportCreate";

import adminMenuConfig from "./store/adminMenuConfig.json";
const { menuItems } = adminMenuConfig;

const DEFAULT_TITLE = "Continuum";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      component: LandingApp,
      name: "root",
      path: "/",
    },
    {
      component: TrainingAgreementApp,
      name: "trainingAgreement",
      path: "/training-agreement",
      meta: {
        title: "Continuum Training Agreement",
      },
    },
    {
      beforeEnter(to, from, next) {
        const canImport = store.getters["session/hasReleaseNoteCreateEdit"];
        const isOchinUser = store.getters["session/isOchinUser"];
        if (!canImport || !isOchinUser) {
          next({ path: "/" });
          return;
        }
        next();
      },
      component: JiraQaImportList,
      name: "jiraQaImport",
      path: "/jira-import",
      meta: {
        title: "QA Jira Import",
      },
    },
    {
      beforeEnter(to, from, next) {
        const canImport = store.getters["session/hasReleaseNoteCreateEdit"];
        const isOchinUser = store.getters["session/isOchinUser"];
        if (!canImport || !isOchinUser) {
          next({ path: "/" });
          return;
        }
        if (!store.state.jiraQaImport.selectedIssue) {
          next({ name: "jiraQaImport" });
          return;
        }
        next();
      },
      component: JiraQaImportCreate,
      name: "jiraQaImportCreate",
      path: "/jira-import/create",
      meta: {
        title: "Import QA Jira Issue",
      },
    },
    {
      beforeEnter(to, from, next) {
        const { getters } = store;
        const hasAdminAny = getters["session/hasAdminAny"];

        if (!hasAdminAny) {
          next({ path: "/" });
          return;
        }

        next();
      },
      props: () => {
        return {
          menuItems,
        };
      },
      name: "adminMenu",
      path: "/admin/menu",
      component: AdminMenu,
      meta: {
        title: "Admin Menu",
      },
    },
    {
      path: "/admin",
      beforeEnter(to, from, next) {
        const { getters } = store;
        const hasAdminAny = getters["session/hasAdminAny"];

        if (!hasAdminAny) {
          next({ path: "/" });
          return;
        }

        if (to.fullPath === "/admin" || to.fullPath === "/admin/") {
          next({ path: "/admin/menu" });
        }

        next();
      },
      props: () => {
        return {
          menuItems,
        };
      },
      component: AdminApp,
      children: [
        {
          beforeEnter(to, from, next) {
            const { getters } = store;
            const hasAdminOchin = getters["session/hasAdminOchin"];

            if (!hasAdminOchin) {
              next({ path: "/admin" });
              return;
            }

            next();
          },
          name: "adminDropdownList",
          path: "dropdown",
          component: AdminDropdownList,
          meta: {
            title: "Dropdown Admin",
          },
        },
        {
          beforeEnter(to, from, next) {
            const { getters } = store;
            const hasAdminOchin = getters["session/hasAdminOchin"];

            if (!hasAdminOchin) {
              next({ path: "/admin" });
              return;
            }

            next();
          },
          name: "adminDropdown",
          path: "dropdown/:id",
          component: AdminDropdownView,
          meta: {
            title: "Dropdown Admin",
          },
          props: route => {
            const { params } = route;
            let { id } = params;

            id = parseInt(id, 10);

            return {
              id,
            };
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "adminPackList",
          path: "pack",
          component: AdminPackList,
          meta: {
            title: "Pack Admin",
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "packCreate",
          path: "pack/create",
          component: PackForm,
          meta: {
            title: "Create Pack",
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "packEdit",
          path: "pack/:id/edit",
          component: PackForm,
          meta: {
            title: "Edit Pack",
          },
          props: route => {
            const { params } = route;
            let { id } = params;

            id = parseInt(id, 10);

            return {
              id,
            };
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "adminPackView",
          path: "pack/:id",
          component: AdminPackView,
          meta: {
            title: "Pack Summary View",
          },
          props: route => {
            const { params } = route;
            let { id } = params;

            id = parseInt(id, 10);

            return {
              id,
            };
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "adminServiceAreaCategoryList",
          path: "serviceAreaCategory",
          component: AdminServiceAreaCategoryList,
          meta: {
            title: "Service Area Category List",
          },
        },
        {
          name: "adminServiceAreaCategory",
          path: "serviceAreaCategory/:id",
          component: AdminServiceAreaCategoryView,
          meta: {
            title: "Service Area Category Edit",
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "adminRole",
          path: "role",
          component: AdminRole,
          meta: {
            title: "User Roles",
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "adminServiceArea",
          path: "serviceArea",
          component: AdminServiceAreaList,
          meta: {
            title: "Service Area Admin",
          },
        },
        {
          beforeEnter(to, from, next) {
            redirectUserWithoutOchinAdmin(next);
            next();
          },
          name: "adminUser",
          path: "user",
          component: AdminUserList,
          meta: {
            title: "User Admin",
          },
        },
        {
          name: "adminOrganizationUser",
          path: "organizationUser",
          component: AdminOrganizationUserList,
          meta: {
            title: "Member User Admin",
          },
        },
        {
          name: "adminExtract",
          path: "extract",
          component: AdminExtract,
          meta: {
            title: "Extract",
          },
        },
        {
          name: "adminTags",
          path: "tag",
          component: AdminTagList,
          meta: {
            title: "Member Tag Admin",
          },
        },
        {
          beforeEnter(to, from, next) {
            const { getters } = store;
            const hasAdminOrganization = getters["session/hasAdminOrganization"];

            if (!hasAdminOrganization) {
              next({ path: "/admin" });
              return;
            }

            next();
          },
          name: "adminAutoAssignment",
          path: "auto-assignment",
          component: AdminAutoAssignment,
          meta: {
            title: "Auto Assignment",
          },
        },
        {
          beforeEnter(to, from, next) {
            const { getters } = store;
            const hasAdminOrganization = getters["session/hasAdminOrganization"];

            if (!hasAdminOrganization) {
              next({ path: "/admin" });
              return;
            }

            next();
          },
          name: "adminApplication",
          path: "application-administration",
          component: AdminApplication,
          meta: {
            title: "Application Administration",
          },
        },
        {
          beforeEnter(to, from, next) {
            const { getters } = store;
            const hasAdminOrganization = getters["session/hasAdminOrganization"];

            if (!hasAdminOrganization) {
              next({ path: "/admin" });
              return;
            }

            next();
          },
          name: "adminOrganizationSettings",
          path: "organization-settings",
          component: AdminOrganizationSettings,
          meta: {
            title: "Organization Settings",
          },
        },
      ],
    },
    {
      component: ErrorPage,
      name: "error",
      path: "/error",
      meta: {
        title: "Error",
      },
    },
    {
      component: SearchApp,
      name: "search",
      path: "/search",
      meta: {
        title: "Search",
      },
    },
    {
      path: "/pack/:packId",
      name: "pack",
      component: PackApp,
      children: [
        {
          beforeEnter(to, from, next) {
            const {
              getters,
              state: {
                session: { loggedIn, user },
              },
            } = store;
            const { serviceArea, userConfiguration } = user;
            let currentPackId = 0;

            if (!loggedIn) {
              location.href = "/login";
            }

            currentPackId = to.params.packId || userConfiguration.packId;

            // Get dashboard permissions and determine redirect
            const permissions = {
              hasDashboardQaView: getters["session/hasDashboardQaView"],
              hasDashboardAccountManagerView: getters["session/hasDashboardAccountManagerView"],
              hasDashboardUatView: getters["session/hasDashboardUatView"],
              serviceArea,
            };

            const redirect = getDashboardRedirect(permissions, {
              name: to.name,
              packId: currentPackId,
            });

            if (redirect) {
              return next(redirect);
            }

            next();
          },
          name: "dashboard",
          path: "dashboard",
          component: DashboardApp,
          meta: {
            title: "Dashboard",
          },
        },
        {
          name: "accountManagerDashboard",
          path: "dashboard/accountManager",
          component: DashboardAccountManager,
          meta: { title: "Account Manager Dashboard" },
        },
        {
          name: "qaDashboard",
          path: "dashboard/qa",
          component: DashboardQaAnalyst,
          meta: { title: "QA Analyst Dashboard" },
        },
        {
          beforeEnter: (to, from, next) => {
            const {
              state: {
                session: {
                  user: { isOchinUser },
                },
              },
            } = store;

            if (isOchinUser) {
              next();
              return;
            }

            // if not an ochin user, then they can only go to their own sa dashboard
            const serviceAreaSession = store.state.session.user.serviceArea;
            const serviceAreaRouteParam = to.params.serviceArea;

            if (serviceAreaRouteParam === serviceAreaSession) {
              next();
              return;
            }

            const {
              params: { packId },
            } = to;
            next({ name: "uatDashboard", params: { packId, serviceArea: serviceAreaSession } });
          },
          name: "uatDashboard",
          path: "dashboard/uat/:serviceArea",
          component: DashboardUAT,
          meta: { title: "UAT Dashboard" },
        },
        {
          name: "memberPackEdit",
          path: "member/:serviceAreaId/edit",
          component: MemberPackEdit,
          meta: { title: "Edit Pack Lead" },
          beforeEnter(to, from, next) {
            const { getters } = store;

            const hasPermission = getters["session/hasMemberPackEdit"];

            if (!hasPermission) {
              return next({ name: "error", query: { type: "permissions" } });
            }

            next();
          },
        },
        {
          name: "releaseNoteCreate",
          path: "releaseNote/create",
          component: ReleaseNoteCreate,
          meta: { title: "Create Release Note" },
          beforeEnter(to, from, next) {
            const { getters } = store;

            const hasReleaseNoteCreateEdit = getters["session/hasReleaseNoteCreateEdit"];
            if (!hasReleaseNoteCreateEdit) {
              return next({ name: "error", query: { type: "permissions" } });
            }
            next();
          },
        },
        {
          name: "releaseNoteList",
          path: "releaseNote/list",
          component: ReleaseNoteList,
          meta: {
            title: "Release Note Summary List",
          },
          beforeEnter(to, from, next) {
            const {
              state: {
                session: { user },
              },
            } = store;

            if (!user.isOchinUser) {
              return next({ name: "testPlanList", params: to.params, query: to.query });
            }
            next();
          },
        },
        {
          name: "releaseNotePrint",
          path: "releaseNote/print",
          component: ReleaseNotePrint,
          meta: {
            hideNavbar: true,
            title: "Release Note List Print View",
          },
          beforeEnter(to, from, next) {
            next();
          },
        },
        {
          name: "testPlanList",
          path: "testPlan/list",
          component: TestPlanList,
          meta: {
            title: "Release Note Summary List",
          },
          beforeEnter(to, from, next) {
            const {
              state: {
                session: { user },
              },
            } = store;

            if (!user.permissions.testPlanListView) {
              return next({ name: "releaseNoteList", params: to.params, query: to.query });
            }
            next();
          },
        },
        {
          name: "testPlanPrint",
          path: "testPlan/print",
          component: TestPlanPrint,
          meta: {
            hideNavbar: true,
            title: "Release Note List Print View",
          },
          beforeEnter(to, from, next) {
            next();
          },
        },
        {
          name: "releaseNote",
          path: "releaseNote/:releaseNoteId",
          component: ReleaseNoteApp,
          children: [
            {
              name: "releaseNoteEdit",
              path: "edit",
              component: ReleaseNoteEdit,
              meta: {
                title: "Edit Release Note",
              },
              beforeEnter(to, from, next) {
                const { getters } = store;

                const hasReleaseNoteCreateEdit = getters["session/hasReleaseNoteCreateEdit"];
                if (!hasReleaseNoteCreateEdit) {
                  return next({ name: "error", query: { type: "permissions" } });
                }
                next();
              },
            },
            {
              name: "releaseNoteView",
              path: "view",
              component: ReleaseNoteView,
              meta: {
                title: "Release Note Detail",
              },
              beforeEnter(to, from, next) {
                const {
                  state: {
                    session: { serviceArea, user },
                  },
                } = store;

                const redirect = getMemberRedirect(
                  { isOchinUser: user.isOchinUser, serviceArea },
                  { name: to.name, params: to.params }
                );

                if (redirect) {
                  return next(redirect);
                }

                next();
              },
            },
            {
              path: "testPlan/:serviceAreaId",
              name: "testPlan",
              component: TestPlanApp,
              meta: {
                title: "Member Release Note View",
              },
              beforeEnter: redirectToServiceArea,
              children: [
                {
                  name: "testPlanEdit",
                  path: "edit",
                  component: TestPlanEdit,
                  meta: {
                    title: "Edit Test Plan",
                  },
                  beforeEnter(to, from, next) {
                    const { getters } = store;
                    const hasTestPlanEdit = getters["session/hasTestPlanEdit"];

                    if (!hasTestPlanEdit) {
                      return next({ name: "testPlanView", params: to.params });
                    }
                    next();
                  },
                },
                {
                  name: "testPlanView",
                  path: "view",
                  component: TestPlanView,
                  meta: {
                    title: "View Test Plan",
                  },
                },
              ],
            },
            {
              name: "testStepCreate",
              path: "testStep/create",
              component: TestStepCreate,
              meta: {
                title: "Create Test Step",
              },
              beforeEnter(to, from, next) {
                const { getters } = store;

                const hasReleaseNoteCreateEdit = getters["session/hasReleaseNoteCreateEdit"];
                if (!hasReleaseNoteCreateEdit) {
                  return next({ name: "error", query: { type: "permissions" } });
                }
                next();
              },
            },
            {
              name: "testStep",
              path: "testStep/:testStepId",
              component: TestStepApp,
              meta: {
                title: "Test Step",
              },
              children: [
                {
                  name: "testStepEdit",
                  path: "edit",
                  component: TestStepEdit,
                  meta: {
                    title: "Edit Test Step",
                  },
                  beforeEnter(to, from, next) {
                    const { getters } = store;

                    const hasReleaseNoteCreateEdit = getters["session/hasReleaseNoteCreateEdit"];
                    if (!hasReleaseNoteCreateEdit) {
                      return next({ name: "error", query: { type: "permissions" } });
                    }
                    next();
                  },
                },
                {
                  name: "testStepView",
                  path: "view",
                  component: TestStepView,
                  meta: {
                    title: "Test Step View",
                  },
                },
                {
                  name: "memberTestStep",
                  path: "serviceArea/:serviceAreaId",
                  component: MemberTestStepApp,
                  meta: {
                    title: "Member Test Step",
                  },
                  beforeEnter: redirectToServiceArea,
                  children: [
                    {
                      name: "memberTestStepEdit",
                      path: "edit",
                      component: MemberTestStepEdit,
                      meta: {
                        title: "Edit Member Test Step",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  scrollBehavior(to, from) {
    return { x: 0, y: 0 };
  },
});

function redirectToServiceArea(to, from, next) {
  const {
    state: {
      session: {
        isOchinUser,
        user: { serviceArea },
      },
    },
  } = store;

  if (!isOchinUser && to.params.serviceAreaId !== `${serviceArea}`) {
    const name = to.name;
    const params = Object.assign({}, to.params, { serviceAreaId: `${serviceArea}` });
    next({ name, params });
  }
  next();
}

router.beforeEach((to, from, next) => {
  const {
    state: {
      session: { loggedIn, trainingAgreementAccepted },
    },
  } = store;

  if (!loggedIn && to.name !== "login") {
    location.href = `/login?redirect=${to.fullPath}`;
    return;
  }

  if (!trainingAgreementAccepted && to.name !== "trainingAgreement") {
    return next({ name: "trainingAgreement" });
  }

  if (to.params.packId && to.params.packId !== from.params.packId) {
    const updatedPackId = { packId: parseInt(to.params.packId, 10) };

    store
      .dispatch("session/updateUserConfiguration", updatedPackId)
      .then(() => next())
      .catch(error => {
        console.error(error);
        console.error("Could not save user configuration");
        return next();
      });
  }
  next();
});

router.afterEach(to => {
  const { title } = to.meta;
  document.title = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
});

export default router;

function redirectUserWithoutOchinAdmin(next) {
  const { getters } = store;
  const hasAdminOchin = getters["session/hasAdminOchin"];
  if (!hasAdminOchin) {
    next({ path: "/admin" });
    return;
  }
}
